export const onlyDigits = (value?: string | null) =>
  (value ?? '').replace(/\D/g, '');

const applyPattern = (digits: string, pattern: string) => {
  let result = '';
  let index = 0;

  for (const char of pattern) {
    if (index >= digits.length) break;
    if (char === '9') {
      result += digits[index];
      index++;
    } else {
      result += char;
    }
  }

  return result;
};

export const maskCpf = (value?: string | null) =>
  applyPattern(onlyDigits(value).slice(0, 11), '999.999.999-99');

export const maskCnpj = (value?: string | null) =>
  applyPattern(onlyDigits(value).slice(0, 14), '99.999.999/9999-99');

export const maskCep = (value?: string | null) =>
  applyPattern(onlyDigits(value).slice(0, 8), '99999-999');

export const maskPhone = (value?: string | null) => {
  const digits = onlyDigits(value).slice(0, 11);
  return digits.length <= 10
    ? applyPattern(digits, '(99) 9999-9999')
    : applyPattern(digits, '(99) 99999-9999');
};

export function isValidCpf(value?: string | null) {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  for (const length of [9, 10]) {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += Number(cpf[i]) * (length + 1 - i);
    }
    const digit = ((sum * 10) % 11) % 10;
    if (digit !== Number(cpf[length])) return false;
  }

  return true;
}

export function isValidCnpj(value?: string | null) {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  for (const length of [12, 13]) {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += Number(cnpj[i]) * weights[i + 13 - length];
    }
    const rest = sum % 11;
    const digit = rest < 2 ? 0 : 11 - rest;
    if (digit !== Number(cnpj[length])) return false;
  }

  return true;
}
